module.exports = __webpack_public_path__ + "static/media/ieee-madc.81235aec.png";